import { render } from "./delivery-challans.vue?vue&type=template&id=49bbaa6b&scoped=true"
import script from "./delivery-challans.vue?vue&type=script&lang=js"
export * from "./delivery-challans.vue?vue&type=script&lang=js"

import "./delivery-challans.vue?vue&type=style&index=0&id=49bbaa6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bbaa6b"]])

export default __exports__